// removed by extract-text-webpack-plugin
module.exports = {"linkStyleTooltip":"_2d2YubuKH1","linkStyle":"_3GiBI8mVux","deadLink":"_259fEcKwxP","linkStyle-default":"Q8sNSvKvC-","linkStyle-block":"NPahmEa0xz","linkStyle-file":"VSincAWEuj","linkStyle-button":"UgT56xbJU9","invalidFile":"_2jftRS6kQn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LinkSlatePlugin/LinkSlatePlugin.scss
// module id = 228
// module chunks = 0